import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'react';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  intensity?: 'low' | 'medium' | 'high';
}

const blurMap = {
  low: 'backdrop-blur-sm',
  medium: 'backdrop-blur-md',
  high: 'backdrop-blur-lg',
} as const;

export function GlassCard({ className, intensity = 'medium', children, ...props }: GlassCardProps) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-white/20',
        'bg-white/10 dark:bg-black/20',
        blurMap[intensity],
        'shadow-glass dark:shadow-glass-dark',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
